import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
// import React, { useState } from "react";
// import styled from "styled-components";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import ViewerMode from "../../Models/ViewerMode";
import Box from "../../Styled/Box";
import { RawButton } from "../../Styled/Button";
import { GLYPHS, StyledIcon } from "../../Styled/Icon";
import Spacing from "../../Styled/Spacing";
import TerrainSide from "./TerrainSide";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const WorkbenchSplitScreen = observer(props => {
  var _terria$currentViewer;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const {
    terria
  } = props;
  const isCesiumWithTerrain = terria.mainViewer.viewerMode === ViewerMode.Cesium && terria.mainViewer.viewerOptions.useTerrain && ((_terria$currentViewer = terria.currentViewer) === null || _terria$currentViewer === void 0 || (_terria$currentViewer = _terria$currentViewer.scene) === null || _terria$currentViewer === void 0 ? void 0 : _terria$currentViewer.globe);
  if (!isCesiumWithTerrain) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(_StyledBox, {
      fullWidth: true,
      column: true,
      $_css: theme.darkWithOverlay,
      $_css2: theme.textLight,
      children: [/*#__PURE__*/_jsxs(_StyledBox2, {
        fullWidth: true,
        centered: true,
        justifySpaceBetween: true,
        $_css3: theme.colorSecondary,
        $_css4: theme.textLight,
        children: [/*#__PURE__*/_jsx(Box, {
          children: t("workbench.splitScreenMode")
        }), /*#__PURE__*/_jsx(_StyledRawButton, {
          onClick: () => {
            runInAction(() => terria.showSplitter = !terria.showSplitter);
          },
          children: /*#__PURE__*/_jsx(StyledIcon, {
            glyph: GLYPHS.close,
            light: true,
            styledWidth: "1em"
          })
        })]
      }), /*#__PURE__*/_jsx(Box, {
        fullWidth: true,
        paddedRatio: 3,
        children: /*#__PURE__*/_jsx(TerrainSide, {
          terria: terria,
          spaced: false,
          buttonProps: {
            css: "border: 0;\n                padding: 8px 0;\n                border-radius: 3px;\n                &:nth-of-type(even) {\n                  border-radius: 0;\n                }\n              "
          },
          activeColor: theme.colorSecondary
        })
      })]
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    })]
  });
});
export default WorkbenchSplitScreen;
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            background: ", ";\n            color: ", ";\n            border-radius: 2px;\n            flex-basis: 145px;\n          "])), p => p.$_css, p => p.$_css2);
var _StyledBox2 = _styled2(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n              background: ", ";\n              border-radius: 2px 2px 0 0;\n              padding: 0 10px;\n              font-weight: bold;\n              font-size: 14px;\n              color: ", ";\n              line-height: 34px;\n            "])), p => p.$_css3, p => p.$_css4);
var _StyledRawButton = _styled3(RawButton).withConfig({
  displayName: "WorkbenchSplitScreen___StyledRawButton",
  componentId: "sc-ztbsb0-0"
})(["display:flex;align-items:center;"]);